import styled from 'styled-components';

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
`;

export const StyledMain = styled.main`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 0;
    background-color: transparent;

    @media (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        padding: 0 1.5rem 4.8rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.l.min}) {
        padding: 0 1.5rem 7.2rem;
    }
`;

export const StyledContent = styled.div`
    flex: 1;
    width: 100%;
    max-width: 128rem;
    margin: auto;
`;
